var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 33.9 33.9",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.17,20.92a.5.5,0,0,0-.5.5l-.05,1.16-10.52,0,.05-7.85h2a.5.5,0,0,0,.5-.5.5.5,0,0,0-.5-.5h-2A1,1,0,0,0,9.1,14.73v7.8a1,1,0,0,0,1.05,1H20.62a1,1,0,0,0,1.05-1V21.42A.5.5,0,0,0,21.17,20.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.49,14.66l-4-4a1,1,0,0,0-1.79.75v1.34a7.49,7.49,0,0,0-4.81,2.06,7.11,7.11,0,0,0-2,4.67,1,1,0,0,0,.78,1A1.07,1.07,0,0,0,13.84,20c.92-1.61,3.39-1.86,4.82-1.87v1.35a1,1,0,0,0,.64,1,1.19,1.19,0,0,0,.41.08,1.05,1.05,0,0,0,.74-.31l4-4a1.08,1.08,0,0,0,0-1.49Zm-.71.78-4.12,4V17.6a.51.51,0,0,0-.49-.5h-.46c-1.64,0-4.56.31-5.83,2.35a6,6,0,0,1,1.67-4,6.71,6.71,0,0,1,4.63-1.8.5.5,0,0,0,.48-.5l.08-1.85,4,4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,33.9A17,17,0,1,1,33.9,17,17,17,0,0,1,17,33.9ZM17,1a16,16,0,1,0,16,16A16,16,0,0,0,17,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportClose);
export default __webpack_public_path__ + "static/media/export_close.fb8b190c20c5110673cdc20dfe415d1e.svg";
export { ForwardRef as ReactComponent };